import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { Icon, Card, Transition, Modal, Button, Header } from 'semantic-ui-react';
import { POPUP, RELOAD } from '../../api/paidit-api';

import './Alert.scss';

const Alert = () => {
    const alert = useSelector(state => state.alerts && state.alerts[0]);
    const text = alert && alert.type === POPUP ? alert.text : i18next.t('general.oopsReload');

    return (
        <Fragment>
            <div className="pi-alert">
                <Transition animation={`fly ${i18next.dir() === 'rtl' ? 'left' : 'right'}`} duration={400} visible={!!(alert && alert.type === POPUP)}>
                    <Card className="alert-container" style={{ borderRadius: `${i18next.dir() === 'rtl' ? '40px 0 40px 40px' : '0 40px 40px 40px'}` }}>
                        <Icon name="exclamation circle" color="red" size="big" />
                        <span>{text}</span>
                    </Card>
                </Transition>
            </div>

            <Modal open={alert && alert.type === RELOAD} basic size="small" className="pi reload-alert">
                <Header className="alert-header">
                    <Icon name="exclamation circle" color="red" size="big" />
                    <span>{text}</span>
                </Header>
                <Modal.Actions className="pi actions">
                    <Button inverted onClick={() => setTimeout(() => window.location.reload(), 100)}>
                        {i18next.t('general.approve')}
                    </Button>
                </Modal.Actions>
            </Modal>
        </Fragment>
    );
};

Alert.propTypes = {
    message: PropTypes.string
};

export default Alert;
